// Minimal cookie helpers (no external dependency).
// The app has no cookie library; the Facebook promo modal needs to remember the
// last calendar day it was shown so it appears at most once per device-local day.

/**
 * Read a cookie value by name. Returns null when absent.
 * @param {string} name
 * @returns {string|null}
 */
export function getCookie(name) {
    if (typeof document === 'undefined') return null;
    const prefix = `${encodeURIComponent(name)}=`;
    const parts = document.cookie ? document.cookie.split('; ') : [];
    for (const part of parts) {
        if (part.startsWith(prefix)) {
            return decodeURIComponent(part.slice(prefix.length));
        }
    }
    return null;
}

/**
 * Write a cookie. Defaults to a 365-day lifetime, path=/ and SameSite=Lax.
 * @param {string} name
 * @param {string} value
 * @param {{ days?: number }} [options]
 */
export function setCookie(name, value, { days = 365 } = {}) {
    if (typeof document === 'undefined') return;
    const maxAge = Math.max(0, Math.floor(days * 24 * 60 * 60));
    document.cookie =
        `${encodeURIComponent(name)}=${encodeURIComponent(value)}` +
        `; path=/; max-age=${maxAge}; SameSite=Lax`;
}

/**
 * Today's date as a device-local `YYYY-MM-DD` string. Used as the "shown today"
 * marker so the day rolls over at the user's own local midnight.
 * @returns {string}
 */
export function todayLocalDate() {
    // en-CA formats as YYYY-MM-DD in the device's local timezone.
    return new Date().toLocaleDateString('en-CA');
}
